import React from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { sortedIndex } from 'lodash';
import { reduxForm, change, getFormValues } from 'redux-form';
import { compose } from 'redux';
import './CountryMappingForm.scss';
import { Box, Button, Icon } from '../../../../common/components';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import SchemesToUpdate from '../SchemesToUpdate/SchemesToUpdate';

const CountryMappingForm = ({
  updateCountryMapping,
  handleSubmit,
  schemesToUpdate,
  statuses,
  numSchemes,
  formValues,
  array,
}) => {
  // const [excludeCountry, setExcludeCountry] = useState('');

  if (!formValues) {
    return null;
  }

  const mappedDestinations = formValues?.destinations_mapping;
  const availableDestinations = formValues?.available_destinations;
  // const excludeDestinations = formValues?.exclude_destinations;

  const removeCountry = (index, country) => {
    const destinationIndex = mappedDestinations.findIndex(
      (destination) => destination.country === country,
    );

    array.splice('destinations_mapping', destinationIndex, 1);

    if (country) {
      const availableDestinationInsertAt = sortedIndex(availableDestinations, country);
      array.splice('available_destinations', availableDestinationInsertAt, 0, country);
    }
  };

  const handleAddCountry = (row, cellName, cellValue) => {
    if (cellName === 'country') {
      const newDestinationIndex = availableDestinations.indexOf(cellValue);
      array.splice('available_destinations', newDestinationIndex, 1);
    }
  };

  const handleAdd = () => {
    const newCountry = { id: '', country: '', status: 0 };
    array.unshift('destinations_mapping', newCountry);
  };

  const remove = (cell, row, enumObject, index) => {
    const handleRemoveCountry = () => {
      return removeCountry(index, cell);
    };

    return (
      <span onClick={handleRemoveCountry}>
        <Icon name="minus-square" size={'fa-1x'} />
      </span>
    );
  };

  const tableOptions = {
    defaultSortName: 'id',
    defaultSortOrder: 'asc',
  };

  const cellEditProp = {
    mode: 'click',
    blurToSave: true,
    afterSaveCell: handleAddCountry,
  };

  const availableCountries =
    availableDestinations && availableDestinations.length > 0
      ? availableDestinations.join(', ')
      : '';

  // const excludeCountries = excludeDestinations && excludeDestinations.length > 0
  //   ? excludeDestinations.join(', ') : '';

  // const handleExcludeCountries = (excludeCountry) => () => {
  //   setExcludeCountry(excludeCountry);
  // };
  //
  // const handleRemoveExcludeCountry = () => {
  //   const index = excludeDestinations.indexOf(excludeCountry);
  //
  //   if (index !== -1) {
  //     excludeDestinations.splice(index, 1);
  //     array.splice('exclude_destinations', excludeDestinations, 1);
  //     setExcludeCountry('');
  //   }
  // };
  //
  // const handleAddExcludeCountry = () => {
  //   if (!excludeDestinations.includes(excludeCountry)) {
  //     excludeDestinations.push(excludeCountry);
  //     array.splice('exclude_destinations', excludeDestinations.sort(), 1);
  //     setExcludeCountry('');
  //   }
  // };

  return (
    <Box>
      <h3>Country Mapping</h3>
      <SchemesToUpdate schemes={schemesToUpdate} />
      <Row className="margin-top">
        <Col sm={12}>
          {numSchemes > 0 ? (
            <div>
              <BootstrapTable
                replace
                data={mappedDestinations}
                name="destinationMappings"
                options={tableOptions}
                className="country-mapping"
                maxHeight="600px"
                cellEdit={cellEditProp}
              >
                <TableHeaderColumn dataField="id" isKey dataSort hidden />
                <TableHeaderColumn
                  dataField="country"
                  className="country-mapping-header country-mapping-header-country"
                  filter={{ type: 'TextFilter', delay: 1000, placeholder: 'Search' }}
                  editable={{
                    type: 'select',
                    options: { values: availableDestinations },
                  }}
                  dataSort
                >
                  Country
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="status"
                  filterFormatted
                  className="country-mapping-header country-mapping-header-status"
                  dataFormat={formatStatus}
                  formatExtraData={statuses}
                  dataSort
                  filter={{ type: 'SelectFilter', options: statuses }}
                  editable={{
                    type: 'select',
                    options: { values: Object.keys(statuses) },
                  }}
                >
                  Region
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataFormat={remove}
                  editable={false}
                  className="country-mapping-header country-mapping-header-remove"
                  dataField="country"
                  columnClassName="country-mapping-remove-country"
                  width={'5%'}
                />
              </BootstrapTable>
              <div className="margin-top">
                <Button
                  bsStyle="secondary"
                  className="pull-right pad-right margin-top"
                  handleClick={handleAdd}
                >
                  Add Country
                </Button>
              </div>
            </div>
          ) : (
            <BootstrapTable
              data={mappedDestinations}
              name="destinationMappings"
              options={tableOptions}
              className="country-mapping"
              maxHeight="600px"
            >
              <TableHeaderColumn dataField="id" isKey dataSort hidden />
              <TableHeaderColumn
                dataField="country"
                className="country-mapping-header country-mapping-header-country"
                filter={{ type: 'TextFilter', delay: 1000 }}
                dataSort
                width={'50%'}
              >
                Country
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="status"
                filterFormatted
                className="country-mapping-header country-mapping-header-status"
                dataFormat={formatStatus}
                formatExtraData={statuses}
                dataSort
                filter={{ type: 'SelectFilter', options: statuses }}
                width={'50%'}
              >
                Region
              </TableHeaderColumn>
            </BootstrapTable>
          )}
        </Col>
      </Row>
      <Row className="margin-top">
        <Col sm={12}>
          <h3>Available Countries</h3>
          {/*<h3>Excluded Countries</h3>*/}
          {/*<p className="excluded-countries">{excludeCountries}</p>*/}
          <p className="excluded-countries">{availableCountries}</p>
        </Col>
      </Row>
      {/*<Row className="margin-top">*/}
      {/*<Col sm={3} md={4}>*/}
      {/*  <Button*/}
      {/*    bsStyle="secondary"*/}
      {/*    className="pull-left btn-padding-large btn-block"*/}
      {/*    handleClick={handleAddExcludeCountry}*/}
      {/*  >*/}
      {/*    Add Excluded Country*/}
      {/*  </Button>*/}
      {/*</Col>*/}
      {/*  <Col sm={9} md={8} className={"country-mapping"}>*/}
      {/*    <DropdownButton*/}
      {/*      pullRight*/}
      {/*      bsSize="small"*/}
      {/*      title={'Available Countries'}*/}
      {/*      className="pull-left btn-padding-large btn-block"*/}
      {/*      bsStyle={'default'}*/}
      {/*    >*/}
      {/*      {availableDestinations.map((availableDestination) => (*/}
      {/*        <MenuItem*/}
      {/*          eventKey={availableDestination}*/}
      {/*          onClick={handleExcludeCountries(availableDestination)}*/}
      {/*        >*/}
      {/*          {availableDestination}*/}
      {/*        </MenuItem>*/}
      {/*      ))}*/}
      {/*    </DropdownButton>*/}
      {/*  </Col>*/}
      {/*</Row>*/}
      {/*<Row>*/}
      {/*<Col sm={3} md={4}>*/}
      {/*  <Button*/}
      {/*    bsStyle="secondary"*/}
      {/*    className="pull-left btn-padding-large btn-block"*/}
      {/*    type="button"*/}
      {/*    handleClick={handleRemoveExcludeCountry}*/}
      {/*  >*/}
      {/*    Remove Excluded Country*/}
      {/*  </Button>*/}
      {/*</Col>*/}
      {/*  <Col sm={9} md={8} className={"country-mapping"}>*/}
      {/*    <DropdownButton*/}
      {/*      pullLeft*/}
      {/*      bsSize="small"*/}
      {/*      title={'Excluded Countries'}*/}
      {/*      bsStyle={'default'}*/}
      {/*      className="pull-left btn-padding-large btn-block"*/}
      {/*    >*/}
      {/*      {excludeDestinations.map((excludeDestination) => (*/}
      {/*        <MenuItem*/}
      {/*          eventKey={excludeDestination}*/}
      {/*          onClick={handleExcludeCountries(excludeDestination)}*/}
      {/*        >*/}
      {/*          {excludeDestination}*/}
      {/*        </MenuItem>*/}
      {/*        ))}*/}
      {/*    </DropdownButton>*/}
      {/*  </Col>*/}
      {/*</Row>*/}
      {numSchemes > 0 && (
        <Row>
          <Col sm={12}>
            <Button
              bsStyle="primary"
              className="pull-right margin-top"
              type="button"
              handleClick={handleSubmit(updateCountryMapping)}
            >
              Save Changes
            </Button>
          </Col>
        </Row>
      )}
    </Box>
  );
};

const formatStatus = (cell, row, status) => {
  return status[cell];
};

export default compose(
  connect(
    (state, props) => {
      return {
        form: props.formName,
        formValues: getFormValues(props.formName)(state),
        initialValues: {
          destinations_mapping: props.destinationsMapping,
          trip_type: props.tripType,
          available_destinations: props.unassignedCountries,
          exclude_destinations: props.excludeCountries,
          schemes: props.schemesToUpdate,
        },
      };
    },
    {
      change: change,
    },
  ),
  reduxForm({}),
)(CountryMappingForm);
